import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AbpHttpInterceptor } from 'abp-ng2-module';

import * as ApiServiceProxies from './service-proxies';

@NgModule({
    providers: [
        ApiServiceProxies.RoleServiceProxy,
        ApiServiceProxies.SessionServiceProxy,
        ApiServiceProxies.TenantServiceProxy,
        ApiServiceProxies.UserServiceProxy,
        ApiServiceProxies.TokenAuthServiceProxy,
        ApiServiceProxies.AccountServiceProxy,
        ApiServiceProxies.ConfigurationServiceProxy,
        ApiServiceProxies.ZoneServiceProxy,
        ApiServiceProxies.ServisTalepleriServiceProxy,
        ApiServiceProxies.EbaServisFormuServiceProxy,
        ApiServiceProxies.PeriyodikBakimServiceProxy,
        ApiServiceProxies.MixAgentServiceProxy,
        ApiServiceProxies.DashboardServiceProxy,
        ApiServiceProxies.DosyaDagitmaServiceProxy,
        ApiServiceProxies.GdataUploadServiceProxy,
        ApiServiceProxies.GdataBaglantiDurumlariServiceProxy,
        ApiServiceProxies.KullaniciHareketleriServiceProxy,
        ApiServiceProxies.DinamikRaporlarServiceProxy,
        ApiServiceProxies.FileExplorerServiceProxy,
        ApiServiceProxies.DownloadFileServiceProxy,
        ApiServiceProxies.FileExplorerServiceProxy,
        { provide: HTTP_INTERCEPTORS, useClass: AbpHttpInterceptor, multi: true }
    ]
})
export class ServiceProxyModule { }
